import { useEffect, useState } from "react";
import { canInstall, onInstallChange, promptInstall } from "@/lib/install";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

/* Mostra "Installa app" SOLO quando l'installazione è disponibile su richiesta
   (Android/Chrome). Su iPhone non compare: l'utente usa Condividi → Aggiungi a Home. */
export default function InstallAppButton({ className = "", variant = "ghost" }) {
  const [avail, setAvail] = useState(canInstall());
  useEffect(() => onInstallChange(setAvail), []);
  if (!avail) return null;
  return (
    <Button data-testid="install-app-btn" size="sm" variant={variant} onClick={promptInstall} className={className}>
      <Download size={15} className="sm:mr-1.5" /> <span className="hidden sm:inline">Installa app</span>
    </Button>
  );
}
